module.exports = __webpack_public_path__ + "img/dswm-4-sm.52e5618a.jpg";